<template>
  <!--支持银行卡列表-->
  <div v-if="isHoldBank" class="popFixed">
    <div class="masking" @click="closePoP()" />
    <div class="tcCon">
      <div class="item">
        <span>支持的银行卡</span>
      </div>
      <div class="holdBank">
        <ul v-if="logoList&&logoList.length>0">
          <li v-for="(bank,index) in bankList"><img :src="require('@/assets/images/bank/bank_icon/'+logoList[index]+'.png')"><p>{{ bank.nameCN }}</p></li>
        </ul>
      </div>
      <div class="btnCon only">
        <span @click="closePoP()">我知道了</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HoldBankList',
  props: ['show', 'bankList'],
  data() {
    return {
      isHoldBank: this.show,
      bankLogoList: process.env.VUE_APP_BANKLOGO,
      logoList: []
    }
  },
  mounted() {
    this.bankLogo()
  },
  methods: {
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    bankLogo() {
      for (const i in this.bankList) {
        if (this.bankLogoList.indexOf(this.bankList[i].code) >= 0) {
          this.logoList.push(this.bankList[i].code)
        } else {
          this.logoList.push('bank')
        }
      }
    },
    closePoP() {
      this.toggleFixed()
      this.isHoldBank = !this.isHoldBank
      this.$emit('cancel', this.isHoldBank)
    }
  }
}
</script>
